import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { store } from '../../store';
import { openConfirmSnackBar, sendPost } from '../../actions'
import { postTerceroPassUdp } from '../../actions/postTerceroPassUdp';

const validate = values => {
    const errors = {}
    const requiredFields = [
        'password', 'passwordC',
        'email',
        'terceroNombre1',
        'terceroApellido1',
        'terceroDireccion',
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Requerido'
        }
    })
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'E-Mail no valido.'
    }
    if (values['password'] != values['passwordC']) {
        errors.password = 'Contraseña no coincide.'
    }

    if (values.password && values.password.length < 6) {
        errors.password = 'La contraseña debe ser de seis (6) caracteres mínimo...'
    }

    if (hasUpper(values.password)) {
        errors.password = 'La contraseña debe contener mínimo una letra en mayúsculas...'
    }

    return errors
}

const renderTextFieldb = (
    { input, label, meta: { touched, error }, ...custom },
) => (
        <TextField
            //hintText={label}
            //floatingLabelText={label}
            //errorText={touched && error}
            {...input}
            {...custom}
        />
    );

const renderTextField = ({
    label, name, type,
    input,
    meta: { touched, invalid, error },
    ...custom
}) => (
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
            variant="outlined"
            margin="normal"

            fullWidth
            type={type}
            //id={name}

            autoComplete={name}
        />
    )


const mapStateToProps = state => ({
    initialValues: state.auth,
    loggedIn: state.auth.loggedIn,
    auth: state.auth,

});



//const FrmRegistro = ({ classes, handleSubmit, submitting, onBack, pristine, submitSucceeded }) => {
const FrmRegistro = props => {
    const { handleSubmit, pristine, reset, submitting, classes } = props;
    const [open, setOpen] = React.useState(false);

    const [terceroPasswordActual, setTerceroPasswordActual] = React.useState('');
    const [terceroPasswordNuevo, setTerceroPasswordNuevo] = React.useState('');
    const [terceroPasswordNuevoC, setTerceroPasswordNuevoC] = React.useState('');


    function handleClickOpen() {
        //console.log("vuamos con el cambio de clave");
        setTerceroPasswordActual('');
        setTerceroPasswordNuevo('');
        setTerceroPasswordNuevoC('');
        setOpen(true);
    }

    function handleClose(e) {
        /*
          
        if (hasUpper(values.password)) {
            errors.password = 'La contraseña debe contener mínimo una letra en mayúsculas...'
        }
        */

        //console.log(e.target.innerHTML);
        //console.log(terceroPasswordActual + ' | ' + terceroPasswordNuevo + ' | ' + terceroPasswordNuevoC);

        if (e.target.innerHTML === 'Confirmar') {

            if (terceroPasswordNuevo !== terceroPasswordNuevoC) {
                store.dispatch(openConfirmSnackBar('Error: Las contraseña no coinciden.,updatePasswordError'));
                return;
            }
            if (terceroPasswordNuevo.length < 6) {
                store.dispatch(openConfirmSnackBar('Error: La nueva contraseña debe ser de seis (6) caracteres mínimo...'));
                return;
            }
            if (terceroPasswordActual.length < 2) {
                store.dispatch(openConfirmSnackBar('Error: La contraseña actual no es valida...'));
                return;
            }
            if (hasUpper(terceroPasswordNuevo)) {
                store.dispatch(openConfirmSnackBar('Error: La contraseña debe contener mínimo una letra en mayúsculas...'));
                return;
            }

            store.dispatch(sendPost());


            var post = {
                terceroID: props.auth.terceroID,
                terceroPassword: terceroPasswordActual,
                terceroPasswordNuevo: terceroPasswordNuevo,
            }

            var formBody = [];

            for (var property in post) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(post[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }

            formBody = formBody.join("&");

            const info = props.postTerceroPassUdp(formBody);
            return info;
        }

        setOpen(false);
    }

    function terceroPasswordActualChange(e) {
        setTerceroPasswordActual(e.target.value);
    }
    function terceroPasswordNuevoChange(e) {
        setTerceroPasswordNuevo(e.target.value);
    }
    function terceroPasswordNuevoCChange(e) {
        setTerceroPasswordNuevoC(e.target.value);
    }


    return (
        <div>
            <form className={classes.form} onSubmit={handleSubmit} >

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Field name="terceroNombre1" component={renderTextField} label="Primer nombre" type="text" autoFocus />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Field name="terceroNombre2" component={renderTextField} label="Segundo nombre" type="text" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Field name="terceroApellido1" component={renderTextField} label="Primer apellido" type="text" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Field name="terceroApellido2" component={renderTextField} label="Segundo apellido" type="text" />
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Field name="terceroMail" component={renderTextField} label="E-Mail" type="text" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Field name="terceroDireccion" component={renderTextField} label="Dirección" type="text" />
                    </Grid>
                </Grid>



                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Field name="terceroTel" component={renderTextField} label="Teléfono" type="text" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Field name="terceroCel" component={renderTextField} label="Celular" type="text" />
                    </Grid>
                </Grid>

                {props.loggedIn ? '' :
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Field name="password" component={renderTextField} label="Contraseña" type="password" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Field name="passwordC" component={renderTextField} label="Confirme contraseña" type="password" />
                        </Grid>
                    </Grid>
                }

                <Grid container spacing={2}>


                    <Grid item xs={12} sm={6} >

                    </Grid>

                    <Grid className={classes.formularioOpciones} item xs={12} sm={3} onClick={handleClickOpen} >
                        {props.loggedIn ? <Link href="#" variant="body2">{"Cambiar contraseña"}</Link> : ''}
                    </Grid>

                    <Grid item xs={12} sm={3} >

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={pristine || submitting}
                            className={classes.submit}>Enviar</Button>
                    </Grid>
                </Grid>
            </form>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Cambiar la contraseña.</DialogTitle>
                <DialogContent>
                    <DialogContentText>Puedes cambiar tu contraseña por motivos de seguridad</DialogContentText>
                    <TextField onChange={terceroPasswordActualChange}
                        autoFocus
                        margin="dense"
                        id="terceroPasswordActual"
                        label="Contraseña actual"
                        type="password"
                        fullWidth
                    />
                    <TextField onChange={terceroPasswordNuevoChange}
                        margin="dense"
                        id="terceroPasswordNuevo"
                        label="Contraseña Nueva"
                        type="password"
                        fullWidth
                    />
                    <TextField onChange={terceroPasswordNuevoCChange}
                        margin="dense"
                        id="terceroPasswordNuevoC"
                        label="Contraseña Nueva"
                        type="password"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">Cancelar</Button>
                    <Button onClick={handleClose} color="primary">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

FrmRegistro.propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    //age: PropTypes.number,
    //onBack: PropTypes.func.isRequired,
};


export default connect(mapStateToProps, { postTerceroPassUdp })(reduxForm({
    form: 'FrmRegistro', validate, enableReinitialize: true
})(FrmRegistro));

function hasNumber(value) {
    return value.match(/\d+/g) != null;
}

function hasUpper(value) {

    if (!(value === undefined)) {

        return value.match(/[A-Z]+/g) == null;
    }
    else {

        return true;
    }
}

function hasLower(value) {
    return value.match(/[a-z]+/g) != null;
}

function hasSpecial(value) {
    // eslint-disable-next-line
    const exp = new RegExp(/[\~\`\!\@\#\$\%\^\&\*\(\)\-\=\[\]\'\;\\\/\.\,\<\>\?\:\"\{\}\+\_\"]+/g);
    return value.match(exp) != null;
}


/*
<Grid container>
        <Grid item xs>
            <Link href="#" variant="body2">
                Olvidó su contraseña?
  </Link>
        </Grid>
        <Grid item>
            <Link href="#" variant="body2">
                {"¿Aún no tienes cuenta? Regístrate"}
            </Link>
        </Grid>
    </Grid>

    */